import React from 'react';
import { dispatch } from 'nike-re-framejs';
import { Button } from 'nike-ui/src/components/button/Button';

import i18n from '@i18n';
import TrashIcon from '@/icons/TrashIcon';
import PopupNg from '@/ui/PopupNg';
import { HOME } from '@/routing/routes';
import { navigate } from '@/routing';
import { deleteTicketSaved } from '@/mytickets/saved/handlers';

function DeleteSavedOnProfile({ ticket }) {
    function onClick() {
        PopupNg.dispatcher.close('ticketDetail');
        dispatch(deleteTicketSaved(ticket));
        navigate(HOME);
    }
    return <Button className="red" icon={TrashIcon} label={i18n('commons.button.zrusitTiket')} onClick={onClick} />;
}
export default DeleteSavedOnProfile;
